import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import * as z from "zod";

export const duplicateShipments = {
  name: "duplicateShipments" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    lineItemExternalIdsToInclude: z.array(z.string()).optional(),
  }),
  output: z.object({ newGroups: z.array(FulfillmentGroupDataSchema) }),
};
